import {Grid, Typography} from "@material-ui/core";
import jpgIcon from '../../../../../assets/images/jpgIcon.svg';
import DeleteIcon from '@material-ui/icons/Delete';
import pdfIcon from '../../../../../assets/images/pdfIcon.svg';
import React from "react";
import TextOverflow from "../../../../TextOverflow";
const bytesToMegaBytes = (bytes, digits) => digits ? (bytes / (1024*1024)).toFixed(digits) : (bytes / (1024*1024));

const FileItem = ({file,removeFile, classes}) => {

    return (
            <Grid item container direction="row" alignItems="center" xs={4}>
                <Grid item xs={3} >
                    {
                        file.type === 'application/pdf' ?
                            <img src={pdfIcon} width="35px"/> :
                            <img src={jpgIcon} width="35px"/>
                    }
                </Grid>
                <Grid item container direction="column"  className={classes.fileInfo} xs={6}>
                    <Grid item className={classes.uploadedFileName} >
                        <TextOverflow>{file.name}</TextOverflow>
                    </Grid>
                    <Grid item className={classes.uploadedFileName}>
                        <Typography>{bytesToMegaBytes(file.size,2)} MB</Typography>
                    </Grid>
                </Grid>
                <Grid item xs={3}>
                    <DeleteIcon fontSize="small" onClick={() => removeFile(file)} className={classes.removeFile}/>
                </Grid>
            </Grid>
    );

}
export default FileItem;